import React from "react";
import PropTypes from "prop-types";
import PersonPreview from "components/PersonPreview";
import { userTypes } from "domain/GamesSearch/types";
import classNames from "classnames";
import InvitationsListGroupItem from "components/GameInvitations/List/GroupItem";
import BlackListAlert from "../../../../entities/BlacklistTooltip/index";

//приглашенные списки и игроки game
const InvitationsList = ({ invitations, invitedGroups, players }) => {
    return (
        <div className="players-list">
            {invitedGroups.map((group, key) => {
                return (
                    <InvitationsListGroupItem
                        key={`group-${key}`}
                        group={group}
                        players={players}
                    />
                );
            })}

            {invitations.map(
                ({ id, name, family_name, avatar, blacklisted }) => {
                    const isPlayerSigned = players?.some(
                        (player) => id === player.id
                    );

                    return (
                        <>
                            <div
                                key={`invited-user-${id}`}
                                className={classNames("players-list__item", {
                                    "players-list__item--signed": isPlayerSigned,
                                })}
                            >
                                <PersonPreview
                                    id={id}
                                    family_name={family_name}
                                    name={name}
                                    avatar={avatar}
                                    mods={[`person--row`]}
                                />
                                {blacklisted && blacklisted.length > 0 && (
                                    <BlackListAlert
                                        blacklisted={blacklisted}
                                        id={id + `invite`}
                                    />
                                )}

                                {
                                    <div className="players-list__right">
                                        {isPlayerSigned ? (
                                            <p className="fs-caption ml-auto">
                                                Записался
                                            </p>
                                        ) : (
                                            <p className="fs-caption ml-auto c-gs-label">
                                                Приглашён
                                            </p>
                                        )}
                                    </div>
                                }
                            </div>
                        </>
                    );
                }
            )}
        </div>
    );
};

InvitationsList.defaultProps = {
    invitations: [],
    invitedGroups: [],
};

InvitationsList.propTypes = {
    invitations: PropTypes.arrayOf(userTypes),
    invitedGroups: PropTypes.arrayOf(PropTypes.shape({})),
    players: PropTypes.arrayOf(PropTypes.shape()),
};

export default InvitationsList;
